export * from "./Tabs";
export * from "./TabsRoot";
export * from "./TabsList";
export * from "./TabsTrigger";
export * from "./TabsContent";
